import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { STATUS_SHORT_LABELS, STATUS_TAG_COLORS } from '../constants';

// In Production R8 — the story status tag.
//
// TWO THINGS THAT LOOK LIKE ONE, AND ARE NOT:
// the tag takes its APPEARANCE from the design (bordered, lightly tinted, icon
// + text) but keeps its EXISTING ACTION — clicking it advances the story. The
// written handoff described the tag as a filter; the separate status row above
// already filters, and taking advancement away would remove the fastest action
// on this screen. So: look from the mockup, behaviour from the product.
//
// Icon AND text, deliberately: status must be readable without relying on
// colour, and three of the four hues are blues.
//
// The mockup specifies Lucide glyphs; this app's icon system is MUI Outlined
// (`src/` has no Lucide dependency and the design rule forbids adding a second
// icon set), so these are the nearest MUI equivalents: circle-check, pen,
// double-check, paper plane.
const ICONS = {
  accepted: CheckCircleOutlineIcon,
  in_work: EditOutlinedIcon,
  completed: DoneAllOutlinedIcon,
  sent_to_publisher: SendOutlinedIcon,
};

const FALLBACK = { fg: '#455A64', bg: '#ECEFF1', border: 'rgba(60,74,94,0.30)' };

export default function StatusTag({ status, onClick }) {
  const c = STATUS_TAG_COLORS[status] || FALLBACK;
  const Icon = ICONS[status];
  const label = STATUS_SHORT_LABELS[status] || status;

  return (
    <button
      type="button"
      className="pbnew-status-tag"
      style={{ color: c.fg, background: c.bg, borderColor: c.border }}
      onClick={onClick}
      title="Advance status"
    >
      {Icon && <Icon style={{ fontSize: 18 }} aria-hidden="true" />}
      <span>{label}</span>
    </button>
  );
}
